export default __webpack_public_path__ + "static/media/avatar.38a44048.svg";